import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "/logo-sciad.png";

const LegalPage = () => {
  const { type } = useParams();
  const [legal, setLegal] = useState(null);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const titles = {
    "mentions-legales": "Mentions Légales",
    "politique-confidentialite": "Politique de Confidentialité",
    "cgv": "Conditions Générales de Vente"
  };

  const contentKeys = {
    "mentions-legales": "mentions_legales",
    "politique-confidentialite": "politique_confidentialite",
    "cgv": "cgv"
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [legalRes, settingsRes] = await Promise.all([
          axios.get(`${API}/legal`),
          axios.get(`${API}/settings`)
        ]);
        setLegal(legalRes.data);
        setSettings(settingsRes.data);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B1121] flex items-center justify-center">
        <div className="animate-spin w-12 h-12 border-4 border-[#00CCC2] border-t-transparent rounded-full" />
      </div>
    );
  }

  const content = legal?.[contentKeys[type]] || "";
  const title = titles[type] || "Page légale";

  return (
    <div className="min-h-screen bg-[#0B1121]" data-testid="legal-page">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 glass">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="SCIAD" className="h-12 w-auto" />
          </Link>
          <Link to="/" className="text-slate-300 hover:text-white transition-colors">
            Retour à l'accueil
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-3xl sm:text-4xl font-bold mb-8">
            <span className="gradient-text">{title}</span>
          </h1>
          
          <div 
            className="prose prose-invert prose-lg max-w-none
              prose-headings:text-white prose-headings:font-semibold
              prose-h2:text-2xl prose-h2:mt-8 prose-h2:mb-4
              prose-p:text-slate-300 prose-p:leading-relaxed
              prose-a:text-[#00CCC2] prose-a:no-underline hover:prose-a:underline
              prose-ul:text-slate-300 prose-li:marker:text-[#00CCC2]"
            dangerouslySetInnerHTML={{ __html: content }}
          />

          {settings && (
            <div className="mt-12 pt-8 border-t border-white/10">
              <h2 className="text-xl font-semibold mb-4">Contact</h2>
              <p className="text-slate-300">
                {settings.company_name}<br />
                {settings.address}<br />
                Email : {settings.email}<br />
                {settings.phone && `Téléphone : ${settings.phone}`}
              </p>
            </div>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 bg-[#0B1121] border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 flex flex-wrap justify-center gap-6 text-sm text-slate-400">
          <Link to="/legal/mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link>
          <Link to="/legal/politique-confidentialite" className="hover:text-white transition-colors">Politique de confidentialité</Link>
          <Link to="/legal/cgv" className="hover:text-white transition-colors">CGV</Link>
        </div>
      </footer>
    </div>
  );
};

export default LegalPage;
